import { SharedModule } from '../core/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrimValueAccessorModule } from 'ng-trim-value-accessor';
import { LotListComponent } from "./lot-list/lot-list.component";
import { LotService } from "../core/services/lot.service";
import { LotShowComponent } from './lot-show/lot-show.component';
import { LotStatsComponent } from './lot-stats/lot-stats.component';
import { RouterModule } from '@angular/router';
import { LotVericationBatchTableComponent } from './lot-verication-batch-table/lot-verication-batch-table.component';


@NgModule({
    imports: [

    CommonModule,
        SharedModule,
        FormsModule,
        TrimValueAccessorModule,
        ReactiveFormsModule
    ],
    declarations: [
        LotListComponent,
        LotShowComponent,
        LotStatsComponent,
        LotVericationBatchTableComponent,
    ],
    providers: [LotService],

})
export class LotModule {
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/lot/lot.module.ts